import React, { Component } from 'react';

class ElevatedIngredient extends Component {
	render() {
		return (
			<div className="elevated__ingredient">
				<img className="w-100 d-block d-md-none" src="/images/home/elevated-top.png" alt="" />
				<div className="container-fluid">
					<div className="elevated__ingredient--content">
						<h1 className="elevated__ingredient--title">Elevated Ingredients</h1>
						<p className="elevated__ingredient--paragraph">Our products are formulated by expert dermatologist in Switzerland,  using clean active ingredients only found in the Swiss Alps. Plus, we only  work with suppliers we can bank on, because transparent  supply chains are super important to us.</p>
						<ul className="elevated__ingredient--tabs d-inline-block">
							<li>
								<img className="img-fluid" src="/images/clean-beauty11.svg" alt="" /> 
								<p> CLEAR <br /> BEAUTY ++ </p>
							</li>
							<li>
								<img className="img-fluid" src="/images/switzerland.svg" alt="" /> 
								<p> MADE IN <br /> SWITZERLAND </p>
							</li>
							<li>
								<img className="img-fluid" src="/images/cruelty-free11.svg" alt="" /> 
								<p> CRUELTY <br /> FREE </p>
							</li>
							<li>
								<img className="img-fluid" src="/images/environmentally-friendly11.svg" alt="" /> 
								<p> ENVIRONMENTALLY <br /> FRIENDLY </p>
							</li>
						</ul>
					</div>
				</div>
				<img className="w-100 d-block d-md-none mt-n5" src="/images/home/elevated-bottom.png" alt="" />
			</div>
		);
	}
}


export default ElevatedIngredient